// src/components/Admin/SalasCmp/SalasItem_Salas.jsx

import React, { useState } from "react";
import { Icon } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import { EducaAdd } from "../../../Shared";
import "./SalasItemSalasFree.scss";

// Mapa de categoría -> clase CSS para color
const CIRCLE_COLOR_MAP = {
  "CIENCIAS HUMANAS": "circle--ciencias-humanas",
  "CIENCIAS NATURALES": "circle--ciencias-naturales",
  HISTORIA: "circle--historia",
  MATEMATICAS: "circle--matematicas",
  ARTE: "circle--arte",
  "VIDA SALUDABLE": "circle--vida-saludable",
  OTROS: "circle--gray",
};

export function SalasItemSalasFree({ scene }) {
  const navigate = useNavigate();

  const [showAd, setShowAd] = useState(false);
  const ad = {
    type: "image-text",
    src: "https://mi-cdn.com/banner.jpg",
    title: "¡Prueba Premium!",
    description: "Más funcionalidades sin anuncios.",
    ctaText: "Descubrir",
    ctaLink: "https://educa360.com/store/plan-educa-creator-anual",
  };

  // Navega a la guía de la escena
  const handleInfoClick = () => {
    navigate(`/teacher/guia/${scene.refId}`);
  };


  // Abre la sala (entrar) en una nueva pestaña
  const handleEnterClick = () => {
    window.open(scene.urlsala, "_blank", "noopener,noreferrer");
  };

  const normalizeCategory = (cat) => {
    // Eliminas espacios en extremos
    let clean = cat.trim();
    // Pones todo en mayúsculas
    clean = clean.toUpperCase();
    // Opcional: reemplazar tildes
    clean = clean
      .replace(/Á/g, "A")
      .replace(/É/g, "E")
      .replace(/Í/g, "I")
      .replace(/Ó/g, "O")
      .replace(/Ú/g, "U");
    return clean;
  };

  // Luego:
  const getCircleColorClass = (cat) => {
    const normalized = normalizeCategory(cat);
    //console.log(normalized);
    // "CIENCIAS HUMANAS" => "circle--ciencias-humanas", etc.
    return CIRCLE_COLOR_MAP[normalized] || "circle--gray";
  };

  return (
    <div className="ui-materials">
      <div className="e-card-scene">
        <img
          className="card-banner"
          src={scene.bannertopUrl}
          alt={scene.title}
        />
        <div className="card-body">
          <p className="card-createdby">Creado por: Educa360</p>

          <div className="card-circles">
            {/* Generar un círculo por cada categoría */}
            {Array.isArray(scene.category) &&
              scene.category.map((cat) => (
                <div
                  key={cat}
                  className={`circle ${getCircleColorClass(cat)}`}
                ></div>
              ))}

            {scene.subcategory && (
              <h4 className="card-subcategorie">
                {scene.subcategory.join(", ")}
              </h4>
            )}
          </div>

          <h3 className="card-title">{scene.title}</h3>
          <hr className="card-divider" />

          <div className="card-actions">
            {/* Botón de "entrar": icono eye, sin texto */}
            <button className="btn-icon" onClick={handleEnterClick}>
              <Icon name="eye" />
            </button>

            {/* Botón de "info": icono list, sin texto */}
            <button className="btn-icon" onClick={handleInfoClick}>
              <Icon name="list" />
            </button>

            {/* Botón de "upload": icono sign-in y texto "Añadir Ruta" */}
            <button className="btn-add-route" onClick={() => setShowAd(true)}>
              <Icon name="sign-in" />
              Añadir Ruta
            </button>
            <EducaAdd
              open={showAd}
              onClose={() => setShowAd(false)}
              adData={ad}
              size="tiny"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
